import Vue from 'vue'

import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import {FacilityContract} from "@/components/facility/cards/facilityContracts/models/FacilityContractCardInterfaces";
import flatPickr from "vue-flatpickr-component";
import {
  getFacilityContract,
  updateFacilityContract
} from "@/components/facility/cards/facilityContracts/service/FacilityContractService";
import {convertDateStringToUTCDate} from "@/utils/dateUtil";

export default Vue.component('facility-contract-card', {
  name: 'FacilityContractCard',
  props: {
    'facilityId': { type: [Number,String]}
  },
  data () {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      contract: {} as FacilityContract,
      errors: {startDate: { msg: ''}, endDate: { msg: ''}} as any,
      saving: false
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner,
    flatPickr,
  },
  computed: {
    isAdding(): boolean {
      return false;
    }
  },
  methods: {
    async expandCard() {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.loadData();
      }
    },
    async loadData() {
      this.loadingInitialData = true;
      try {
        const result = await getFacilityContract(this.facilityId);

        if (result.success && result.data[0]) {
          this.contract = result.data[0] as FacilityContract;

          this.contract.startDate = convertDateStringToUTCDate(this.contract.startDate);
          this.contract.endDate = convertDateStringToUTCDate(this.contract.endDate);
          this.contract.lastReviewDate = convertDateStringToUTCDate(this.contract.lastReviewDate);

        } else {
          this.contract = {} as FacilityContract;;
        }

      } catch(err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred fetching Facility-Contract.'
        });
      }
      this.loadingInitialData = false;

    },
    async cancel() {
      this.cardExpanded = false;
    },
    async save() {
      await this.validate();
      if (Object.keys(this.errors).some( (s: any) => this.errors[s].msg !== '')) {
        return;
      }
      this.saving = true;
      try {
        const result = await updateFacilityContract(this.facilityId, this.contract);
        if (result) {
          this.cardExpanded = false;
        } else {
          this.exceptionOccurred();
        }
      } catch (err) {
        this.exceptionOccurred();
      }
      this.saving = false;
    },
    async validate() {
      this.errors = {startDate: { msg: ''}, endDate: { msg: ''}} ;
      if ( ! this.contract.startDate || this.contract.startDate === '') {
        this.errors.startDate.msg = 'Please enter start date.'
      }
      if ( ! this.contract.endDate || this.contract.endDate === '') {
        this.errors.endDate.msg = 'Please enter end date.'
      }
    },
    exceptionOccurred() {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'An error occurred saving Facility-Contract.'
      });
    }
  }})



// WEBPACK FOOTER //
// ./src/components/facility/cards/facilityContracts/FacilityContractCard.ts